const Block = {
	url: "",
	onClick: null,
};

export default {
	Block,
};
